import apiClient from 'api/services/apiClient';
import { MESSAGE_COMMON } from 'constants/string/messages';
import { isApiResponseError, validateMessageResponse } from 'utils/helper';

export const videoCategoryList = async () => {
  const response = await apiClient.request('GET', '/admin/video_category');
  if (!isApiResponseError(response)) {
    return response?.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};
